/* src/app/core/httpErrorPages/device-not-authorized/device-not-authorized.component.less */
:host {
  justify-content: flex-start;
  align-items: flex-start;
  height: 100vh;
  width: 100%;
  color: #000000;
  background-color: #005eb8;
  display: flex;
  align-items: center;
  justify-content: center;
}
:host .text {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  font-size: 4.8rem;
  font-weight: 700;
}
/*# sourceMappingURL=device-not-authorized.component.css.map */
